export default __webpack_public_path__ + "static/media/setting-file.0da3491d.png";